var exports = {
  "M": "ProfileGradient.module__surface___ckozRk",
};

module.exports = exports;
